import type { ComponentType } from 'react';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LegacyAsyncModals = lazyAfterPaint(
	() => import(/* webpackChunkName: "legacy-async-modals" */ './AsyncModals.tsx'),
	{ ssr: false },
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const prioritiesMappingComponents: ComponentType<Record<any, any>>[] = [LegacyAsyncModals];

export const priorityMappingGlobalSettingsLayout: Layout = composeLayouts(globalSettingsLayout, {
	globalComponents: prioritiesMappingComponents,
});
